<div class="form-register">
  <form [formGroup]="formPurchaseOrderDetail">
    <div class="row p-1">
      <div class="col-lg-3 col-md-6 col-sm-6 col-12">
        <app-custom-input-text class="border-radius-right" [disabled]="true" [labelText]="'Artículo'"
          [value]="codeNameArticle" [required]="true">
        </app-custom-input-text>
      </div>
      <div [hidden]="hiddenNoAjusted" class="col-lg-1 col-md-1 col-sm-3 col-6">
        <app-custom-input-decimal ngDefaultControl formControlName="quantity" [labelText]="'Cantidad'" [required]="true"
          (onChangeNumber)="changeQuantity()"></app-custom-input-decimal>
      </div>
      <div [hidden]="hiddenAjusted" class="col-lg-1 col-md-1 col-sm-3 col-6">
        <app-custom-input-decimal ngDefaultControl formControlName="ajustedQuantity" [labelText]="'Cant Aju'"
          [required]="true" (onChangeNumber)="calculateTotals()"></app-custom-input-decimal>
      </div>
      <div [hidden]="hiddenNoAjusted" class="col-lg-1 col-md-1 col-sm-3 col-6">
        <app-custom-input-decimal ngDefaultControl formControlName="unitValue" [labelText]="'Vr. Unit'"
          [required]="true" (onChangeNumber)="changeUnitValue()"></app-custom-input-decimal>
      </div>
      <div [hidden]="hiddenAjusted" class="col-lg-1 col-md-1 col-sm-3 col-6">
        <app-custom-input-decimal ngDefaultControl formControlName="ajustedUnitValue" [labelText]="'Vr. Unit Aju'"
          [required]="true" (onChangeNumber)="calculateTotals()"></app-custom-input-decimal>
      </div>
      <div [hidden]="hiddenNoAjusted" class="col-lg-1 col-md-1 col-sm-3 col-6">
        <app-custom-input-decimal ngDefaultControl formControlName="discountRate" [labelText]="'%Dcto'"
          [required]="true" (onChangeNumber)="changeDiscountRate()"></app-custom-input-decimal>
      </div>
      <div [hidden]="hiddenAjusted" class="col-lg-1 col-md-1 col-sm-3 col-6">
        <app-custom-input-decimal ngDefaultControl formControlName="ajustedDiscountRate" [labelText]="'%Dcto Aju'"
          [required]="true" (onChangeNumber)="calculateTotals()"></app-custom-input-decimal>
      </div>
      <div class="col-lg-1 col-md-1 col-sm-3 col-6">
        <app-custom-input-decimal ngDefaultControl formControlName="subtotalValue"
          [labelText]="'Subtotal'"></app-custom-input-decimal>
      </div>
      <div [hidden]="hiddenNoAjusted" class="col-lg-1 col-md-1 col-sm-3 col-6">
        <app-custom-input-decimal ngDefaultControl formControlName="ivaRate" [labelText]="'%Iva'"
          [required]="true"></app-custom-input-decimal>
      </div>
      <div [hidden]="hiddenAjusted" class="col-lg-1 col-md-1 col-sm-3 col-6">
        <app-custom-input-decimal ngDefaultControl formControlName="ajustedIvaRate" [labelText]="'%Iva Aju'"
          [required]="true"></app-custom-input-decimal>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-12 col-12 d-flex">
        <div class="d-flex align-items-end justify-content-end  gap-2 container-buttons bottom-0">
          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
            (onClick)="send()"></app-custom-button>
          <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
        </div>
      </div>
    </div>
  </form>
</div>